import React from 'react';

function AbaAfiliados({ configAfiliados, handleAfiliadosChange, somenteConsulta = false }) {
  return (
    <div className="routine-panel">
      {somenteConsulta && (
        <div className="routine-callout routine-callout--warm" style={{ marginBottom: '16px' }}>
          <p className="routine-callout__text">
            Perfil técnico em modo somente consulta. As integrações podem ser revisadas, mas não podem ser alteradas.
          </p>
        </div>
      )}

      <fieldset disabled={somenteConsulta} style={{ border: 0, padding: 0, margin: 0 }}>
      <div className="admin-section-stack">
        <section className="routine-surface admin-surface-section">
          <div className="admin-grid-2">
            <div className="routine-field">
              <label className="routine-label">Tag Amazon</label>
              <input
                type="text"
                value={configAfiliados.tag_amazon || ''}
                onChange={(e) => handleAfiliadosChange('tag_amazon', e.target.value)}
                placeholder="Ex: promoalert-20"
                className="routine-input"
              />
            </div>

            <div className="routine-field">
              <label className="routine-label">Tag Shopee</label>
              <input
                type="text"
                value={configAfiliados.tag_shopee || ''}
                onChange={(e) => handleAfiliadosChange('tag_shopee', e.target.value)}
                placeholder="Seu ID de afiliado"
                className="routine-input"
              />
            </div>

            <div className="routine-field routine-field--grow">
              <label className="routine-label">ID Magazine Você (Magalu)</label>
              <input
                type="text"
                value={configAfiliados.magalu_id || ''}
                onChange={(e) => handleAfiliadosChange('magalu_id', e.target.value)}
                placeholder="Ex: magazinepromoalert"
                className="routine-input"
              />
            </div>
          </div>
        </section>

        <section className="routine-surface admin-surface-section">
          <div className="admin-section-stack">
            <div className="routine-callout">
              <h5 className="routine-callout__title">Lomadee</h5>
              <div className="admin-grid-2">
                <div className="routine-field">
                  <label className="routine-label">Source ID</label>
                  <input
                    type="text"
                    value={configAfiliados.source_id_lomadee || ''}
                    onChange={(e) => handleAfiliadosChange('source_id_lomadee', e.target.value)}
                    placeholder="Ex: 2324685"
                    className="routine-input"
                  />
                </div>

                <div className="routine-field routine-field--grow">
                  <label className="routine-label">Lojas parceiras</label>
                  <textarea
                    value={configAfiliados.lojas_lomadee || ''}
                    onChange={(e) => handleAfiliadosChange('lojas_lomadee', e.target.value)}
                    placeholder="Ex: americanas.com.br, centauro.com.br"
                    className="routine-input"
                    style={{ minHeight: '92px', paddingTop: '12px', paddingBottom: '12px', fontFamily: 'monospace' }}
                  />
                </div>
              </div>
            </div>

            <div className="routine-callout">
              <h5 className="routine-callout__title">Awin</h5>
              <div className="admin-grid-2">
                <div className="routine-field">
                  <label className="routine-label">Publisher ID</label>
                  <input
                    type="text"
                    value={configAfiliados.awin_id || ''}
                    onChange={(e) => handleAfiliadosChange('awin_id', e.target.value)}
                    placeholder="Seu ID na Awin"
                    className="routine-input"
                  />
                </div>

                <div className="routine-field routine-field--grow">
                  <label className="routine-label">Lojas parceiras</label>
                  <textarea
                    value={configAfiliados.lojas_awin || ''}
                    onChange={(e) => handleAfiliadosChange('lojas_awin', e.target.value)}
                    placeholder="Ex: aliexpress.com, nike.com.br"
                    className="routine-input"
                    style={{ minHeight: '92px', paddingTop: '12px', paddingBottom: '12px', fontFamily: 'monospace' }}
                  />
                </div>
              </div>
            </div>

            <div className="routine-callout">
              <h5 className="routine-callout__title">Rakuten</h5>
              <div className="admin-grid-2">
                <div className="routine-field">
                  <label className="routine-label">SID</label>
                  <input
                    type="text"
                    value={configAfiliados.rakuten_id || ''}
                    onChange={(e) => handleAfiliadosChange('rakuten_id', e.target.value)}
                    placeholder="Ex: 4344159"
                    className="routine-input"
                  />
                </div>

                <div className="routine-field routine-field--grow">
                  <label className="routine-label">Lojas parceiras</label>
                  <textarea
                    value={configAfiliados.lojas_rakuten || ''}
                    onChange={(e) => handleAfiliadosChange('lojas_rakuten', e.target.value)}
                    placeholder="Ex: sephora.com.br, cobasi.com.br"
                    className="routine-input"
                    style={{ minHeight: '92px', paddingTop: '12px', paddingBottom: '12px', fontFamily: 'monospace' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      </fieldset>
    </div>
  );
}

export default AbaAfiliados;
